module.exports = function toggleChildFields(container) {
	var $email2 = window.jQuery('#email2');
	var $box = $email2.closest('.expandable');

	var isMinor = window.jQuery(container).find('input[name=isMinor][data-minor=true]').is(':checked') === true;
	if (isMinor) {
		window.jQuery('.hideForChild', container).hide();
		window.jQuery('.showForChild', container).show();

		$email2.removeClass('isRequired');
		window.jQuery('#employer').removeClass('isRequired');
		window.jQuery('#title').removeClass('isRequired');

		var saving = window.jQuery('#saveFreqFlyer').is(':checked');
		if (saving) {
			$box.removeClass('active');
		}
	} else {
		window.jQuery('.hideForChild', container).show();
		window.jQuery('.showForChild', container).hide();
		$email2.removeClass('isRequired');

		// attempt a restore of rule if adult/minor toggle is flip flopped
		if(window.jQuery('#employer').data('adultvalidation') == 'required') {
			window.jQuery('#employer').addClass('isRequired');
			window.jQuery('#title').addClass('isRequired');
		}

		var saving = window.jQuery('#saveFreqFlyer').is(':checked');
		if (saving) {
			$box.addClass('active');
			$email2.addClass('isRequired');
		}
	}
};
